module.exports = __webpack_public_path__ + "static/img/drawer2.5fe635b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/drawer/drawer2.png
// module id = qsMI
// module chunks = 12